import { SAVE_CHANNEL_DATA_FAILURE, SAVE_CHANNEL_DATA_REQUEST, SAVE_CHANNEL_DATA_RESET, SAVE_CHANNEL_DATA_SUCCESS } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const saveChannelDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case SAVE_CHANNEL_DATA_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case SAVE_CHANNEL_DATA_REQUEST:
            return Object.assign({}, state);
        case SAVE_CHANNEL_DATA_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case SAVE_CHANNEL_DATA_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, data: null });
        default:
            return state;
    }
};
export default saveChannelDataReducer;
